import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { routes } from "./routes";
import { useAuth } from "../components/auth/AuthenticationContext";

export const SignedOutRoute: React.FC = () => {
  const { state } = useAuth();
  const location = useLocation();

  if (state !== "SIGNED_OUT") {
    const route = (location.state as { route?: string } | null)?.route;

    const to = route ? route : routes.dashboard;

    return <Navigate to={to} replace />;
  }

  return <Outlet />;
};
